import { whyThisProgramTemplate } from './whyThisProgram';
import { goalsAndInterestsTemplate } from './goalsAndInterests';
import { personalStatementTemplate } from './personalStatement';
import { researchInterestTemplate } from './researchInterest';
import { challengeGrowthTemplate } from './challengeGrowth';
import { genericShortAnswerTemplate } from './genericShortAnswer';

export {
  whyThisProgramTemplate,
  goalsAndInterestsTemplate,
  personalStatementTemplate,
  researchInterestTemplate,
  challengeGrowthTemplate,
  genericShortAnswerTemplate
};

// Registry for ConversationalEssayBuilder's templateRegistry prop
export const SUMMER_PROGRAM_TEMPLATE_REGISTRY = {
  whyThisProgram: whyThisProgramTemplate,
  goalsAndInterests: goalsAndInterestsTemplate,
  personalStatement: personalStatementTemplate,
  researchInterest: researchInterestTemplate,
  challengeGrowth: challengeGrowthTemplate,
  genericShortAnswer: genericShortAnswerTemplate
};

// Ordered list for template picker UI
export const SUMMER_PROGRAM_TEMPLATES = [
  whyThisProgramTemplate,
  goalsAndInterestsTemplate,
  personalStatementTemplate,
  researchInterestTemplate,
  challengeGrowthTemplate,
  genericShortAnswerTemplate
];

// Simple keyword-based template suggestion from prompt text
export const suggestTemplate = (promptText) => {
  if (!promptText || promptText.trim().length < 10) return null;
  const lower = promptText.toLowerCase();

  if (lower.includes('why') && (lower.includes('program') || lower.includes('apply') || lower.includes('attend') || lower.includes('choose') || lower.includes('interest in this'))) {
    return 'whyThisProgram';
  }
  if (lower.includes('research') || lower.includes('scientific') || lower.includes('lab') || lower.includes('investigate')) {
    return 'researchInterest';
  }
  if (lower.includes('challenge') || lower.includes('obstacle') || lower.includes('failure') || lower.includes('overcome') || lower.includes('setback') || lower.includes('difficult')) {
    return 'challengeGrowth';
  }
  if (lower.includes('goal') || lower.includes('interest') || lower.includes('aspir') || lower.includes('hope to') || lower.includes('plan to')) {
    return 'goalsAndInterests';
  }
  if (lower.includes('personal') || lower.includes('tell us about yourself') || lower.includes('who you are') || lower.includes('background') || lower.includes('identity') || lower.includes('shaped')) {
    return 'personalStatement';
  }

  return null;
};
